import _ from 'lodash'
import {METHODS} from 'Shared/paymentMethods'

export default function allowedPaymentMethodsFor(renter) {
  return _.filter(METHODS, (method) => renter[`is_payment_via_${method}_allowed`])
}
